document.addEventListener("DOMContentLoaded", () => {
    let currentTooltip = null;
    let currentIcon = null;

    document.addEventListener("click", (e) => {
        const icon = e.target.closest(".declaration-info");
        if (icon) {
            e.stopPropagation();

            // second click = close
            if (currentTooltip && currentIcon === icon) {
                currentTooltip.remove();
                currentTooltip = null;
                currentIcon = null;
                return;
            }

            // delete old tooltip
            if (currentTooltip) {
                currentTooltip.remove();
            }

            const tooltip = document.createElement("div");
            tooltip.className = "custom-tooltip";
            tooltip.innerText = "Deklarację ustawił: " + icon.dataset.memberName;
            document.body.appendChild(tooltip);

            const rect = icon.getBoundingClientRect();
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

            // positioning
            let top = rect.top + scrollTop - tooltip.offsetHeight - 8;
            let left = rect.left + scrollLeft + rect.width + 8;

            if (left + tooltip.offsetWidth > window.innerWidth - 10) {
                left = rect.left + scrollLeft - tooltip.offsetWidth - 8;
            }
            if (top < scrollTop + 10) {
                top = rect.top + scrollTop + rect.height + 8;
            }

            tooltip.style.top = top + "px";
            tooltip.style.left = left + "px";

            currentTooltip = tooltip;
            currentIcon = icon;
        } else {
            // close on click anywhere else
            if (currentTooltip && !currentTooltip.contains(e.target)) {
                currentTooltip.remove();
                currentTooltip = null;
                currentIcon = null;
            }
        }
    });
});
